import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserProfile, PropertyList, YardiUser } from "../typeDefs/userprofiles";

export interface UserProfileState {
    loading: boolean;
    userProfiles: UserProfile[];
    propertyLists: PropertyList[];
    yardiUsers: YardiUser[];
}

const initialState: UserProfileState = {
    loading: false,
    userProfiles: [],
    propertyLists: [],
    yardiUsers: [],
};

export const userprofilesSlice = createSlice({
    name: "userprofiles",
    initialState,
    reducers: {
        setUserProfiles: (state, action: PayloadAction<UserProfile[]>) => {
            state.userProfiles = action.payload;
        },
        setPropertyLists: (state, action: PayloadAction<PropertyList[]>) => {
            state.propertyLists = action.payload;
        },
        setYardiUsers: (state, action: PayloadAction<YardiUser[]>) => {
            state.yardiUsers = action.payload;
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
    },
});

export const { setUserProfiles, setPropertyLists, setYardiUsers, setLoading } =
    userprofilesSlice.actions;

export default userprofilesSlice.reducer;
